export default __webpack_public_path__ + "static/media/vip-lounges.7d9265c0.jpg";